import { useEffect, useState } from "react";
import SalesInvoiceApi from "../../../services/api/salesInvoiceApi";
import { useUser } from "../../../context/userContext";
import { toast } from "react-toastify";
import { toBase64 } from "../../../utils";
import { generateQRInvoicePDF } from "../../../utils/generationPdf";
import { useParams } from "react-router-dom";
import { ThemeLoader } from "../../../components/styled/Elements";

const QRInvoiceWrapper = () => {
  const { id } = useParams();
  const { user } = useUser();
  const [isLoading, setIsLoading] = useState(false);
  const [logoBase64, setLogoBase64] = useState(null);

  const fetchInvoiceDetails = async (id) => {
    try {
      const { data, code } = await SalesInvoiceApi.viewInvoiceDetail(id);
      if (code === 200 && data) {
        // setDataObj(data);
        return data;
      }
    } catch (error) {
      toast.error(error?.message);
      return null;
    } finally {
    }
  };
  const handleDownload = async () => {
    setIsLoading(true);
    try {
        const data = await fetchInvoiceDetails(id);
        await generateQRInvoicePDF(data, logoBase64, "sales_short_invoice.pdf");
    } catch (error) {
        console.log('error: ', error);
    } finally {
        setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user?.organization?.logo) {
      toBase64(
        `${process.env.REACT_APP_ASSET_URL}/${user?.organization?.logo}`,
      ).then(setLogoBase64);
    }
  }, []);

  useEffect(() => {
    handleDownload();
  }, []);

  if(isLoading) return <ThemeLoader />

  return null;
};

export default QRInvoiceWrapper;
